"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRenderCorpBoxComponent = void 0;
var vue_1 = require("vue");
var CardRenderItemComponent_1 = require("./CardRenderItemComponent");
var CardRenderEffectBoxComponent_1 = require("./CardRenderEffectBoxComponent");
var CardRenderSymbolComponent_1 = require("./CardRenderSymbolComponent");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var CardRenderItem_1 = require("../../cards/render/CardRenderItem");
var CardRenderSymbol_1 = require("../../cards/render/CardRenderSymbol");
exports.CardRenderCorpBoxComponent = vue_1.default.component('CardRenderCorpBoxComponent', {
    props: {
        rows: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
    components: {
        CardRenderSymbolComponent: CardRenderSymbolComponent_1.CardRenderSymbolComponent,
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
        CardRenderEffectBoxComponent: CardRenderEffectBoxComponent_1.CardRenderEffectBoxComponent,
    },
    methods: {
        getClasses: function () {
            var classes = ['card-corporation-box'];
            return classes.join(' ');
        },
        getComponentType: function (rowItem) {
            if (rowItem instanceof CardRenderSymbol_1.CardRenderSymbol) {
                return 'symbol';
            }
            else if (rowItem instanceof CardRenderer_1.CardRenderEffect) {
                return 'effect';
            }
            else if (rowItem instanceof CardRenderItem_1.CardRenderItem) {
                return 'item';
            }
            return '';
        },
    },
    template: "\n      <div :class=\"getClasses()\">\n          <div class=\"card-corporation-label\">{{ label }}</div>\n          <div v-for=\"(rowData, index) in rows[0]\" :key=\"index\">\n            <CardRenderItemComponent v-if=\"getComponentType(rowData) === 'item'\" :item=\"rowData\" />\n            <CardRenderSymbolComponent v-else-if=\"getComponentType(rowData) === 'symbol'\" :item=\"rowData\" />\n            <CardRenderEffectBoxComponent v-if=\"getComponentType(rowData) === 'effect'\" :effectData=\"rowData\" />\n          </div>\n      </div>\n    ",
});
//# sourceMappingURL=CardRenderCorpBoxComponent.js.map